import { css as r } from "@microsoft/fast-element";
import { display as t } from "@matrix42/fast-foundation";
import { normalize as e } from "../../common/normalize.js";
import { designTokens as i } from "../../design-tokens.js";
const f = (o) => r`
  ${e}
  ${t("table-header-group")}
  ::slotted(${o.prefix}-trow) {
    /* Typography */
    font-weight: ${i.fontWeight.bold};
  }
`;
export {
  f as tableHeaderStyles
};
